@if (navigationSteps.length > 0) {
  <div class="step-navigation-wrapper no-print">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 large-offset-2 large-8" [class.extra-element]="navigationPostElement || navigationPreElement">
        @if (navigationPreElement) {
          <nav app-step-navigation-extra [navigationElement]="navigationPreElement" [class]="elementClass + ' extra left'"></nav>
        }
        <nav [class]="elementClass">
          @for (step of navigationSteps; track step; let isLast = $last) {
            <div [class]="step.class">
              <a [routerLink]="step.class && step.class?.indexOf('active') > -1? step.path : null"><span [innerHTML]="getPathTextkey(step.path, step.navPostfix) | translate"></span></a>
              @if (step.children.length > 0) {
                <div class="children">
                  <span class="active-status overall hide-for-medium" [style.width]="getActiveWidthOverall(step.children)"></span>
                  <span class="child-section show-for-medium">
                    <span class="active-status" [style.width]="getSectionStartsteps(step.children).length > 0 && getSectionStartsteps(step.children)[0].class.indexOf('active') > -1? '100%' : '0%'"></span>
                  </span>
                  @for (child of getSectionStartsteps(step.children); track child) {
                    <span class="child-section show-for-medium">
                      @if (!isAdvisorEnd) {
                        <a [title]="getPathTextkey(child.path) | translate" [class]="child.class" [routerLink]="child.class && child.class?.indexOf('active') > -1? child.path : null"></a>
                      }
                      @if (!isAdvisorEnd) {
                        <span class="active-status" [style.width]="getActiveWidthChild(child, step.children)"></span>
                      }
                    </span>
                  }
                </div>
              }
            </div>
          }
        </nav>
        @if (navigationPostElement) {
          <nav app-step-navigation-extra [navigationElement]="navigationPostElement" [class]="elementClass + ' extra right'"></nav>
        }
      </div>
    </div>
  </div>
}
